import {
  SALE_FIND_ALL,
  SALE_SET_INITIAL_STATE,
  SALE_VIEW
} from './saleTypes'


const initialState = {
  data: [],
  pagination: {
    currentpage: 1,
    itemcount: 0,
    pagesize: 10,
    firstpage: '',
    lastpage: '',
    nextpages: [],
    prevpages: [],
    totalpages: 0
  },

  viewResult: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SALE_SET_INITIAL_STATE:
      return initialState;
    case SALE_FIND_ALL:
      return {
        data: action.payload.data,
        pagination: action.payload.pagination
      }
    case SALE_VIEW:
    return {
      ...state,
      viewResult: action.payload.data
    }
    default: return state
  }
}

export default reducer
